import React, { ReactNode } from "react";
import { getUnconditionalName } from "./Conditional/HelpersConditional";
import { GamePieceProperty } from "./GamePieceProperty";
import { gamePiecePropertyInfo } from "./HelpersGamePieceProperty";

export function renderNestedNodeContent(data: { [key: string]: any } | number | string, path: string[]): ReactNode {
  let propertiesRendered = new Set<string>();

  const sortProperties = (a: [string, any], b: [string, any]) => {
    const nameA = getUnconditionalName(a[0]);
    const nameB = getUnconditionalName(b[0]);
    const indexA = nameA in gamePiecePropertyInfo ? gamePiecePropertyInfo[nameA].sortedIndex : -1;
    const indexB = nameB in gamePiecePropertyInfo ? gamePiecePropertyInfo[nameB].sortedIndex : -1;
    if (indexA !== -1 && indexB !== -1) return indexA - indexB; // Both keys are in priority list
    if (indexA !== -1) return -1; // Only A is in priority list
    if (indexB !== -1) return 1; // Only B is in priority list

    const textA = nameA.toUpperCase();
    const textB = nameB.toUpperCase();

    return textA < textB ? -1 : textA > textB ? 1 : 0; // Neither key is in priority list sort by alfabet
  };

  return (
    <>
      {Object.entries(data)
        .sort(sortProperties)
        .map(([propName, value]) => {
          let unconditionalName = getUnconditionalName(propName);
          if (propertiesRendered.has(unconditionalName)) {
            return null;
          }
          propertiesRendered.add(unconditionalName);
          return <GamePieceProperty key={propName} propName={propName} value={value} path={path} fullObject={data} />;
        })}
    </>
  );
}
